import React, { useEffect, useState } from 'react';

import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router';

import Button from 'components/Button';
import Popup from 'components/Popup';
import Typography from 'components/Typography';

import { redirectTo } from 'helpers/history';

import useHiddenWithCookie from 'hooks/useHiddenWithCookie';
import { useTracking } from 'hooks/useTracking';

const Under18Modal = () => {
  return (
    <>
      <Typography variant="h2" color="white">
        <FormattedMessage id="components.FranceAgeConfirmationModal.Under18.title" />
      </Typography>
      <br />
      <Typography variant="body" color="white">
        <FormattedMessage id="components.FranceAgeConfirmationModal.Under18.body" />
      </Typography>
      <br />
      <Button
        variant="primary"
        title={{ id: 'components.FranceAgeConfirmationModal.Under18.link' }}
        linkTo="https://www.instagram.com/femtasy_fr/"
        className="over_18"
      />
    </>
  );
};

const AgeConfirmationModal = ({ onHide, onConfirmationClick }) => {
  const { trackContentInteraction } = useTracking();

  return (
    <>
      <Typography variant="h2" color="white">
        <FormattedMessage id="components.FranceAgeConfirmationModal.title" />
      </Typography>
      <br />
      <Typography variant="body" color="white">
        <FormattedMessage id="components.FranceAgeConfirmationModal.body" />
      </Typography>
      <br />
      <Button
        variant="primary"
        title={{ id: 'components.FranceAgeConfirmationModal.over18' }}
        onClick={onHide}
        className="over_18"
      />
      <Button
        variant="secondary"
        title={{ id: 'components.FranceAgeConfirmationModal.below18' }}
        className="under_18 mt-2"
        onClick={() => {
          trackContentInteraction('no', 'pop_ups', 'are_you_18');
          onConfirmationClick(true);
        }}
      />
    </>
  );
};

interface IProps {
  delay: number;
}

const FranceAgeConfirmationModal = ({ delay }: IProps) => {
  const { trackContentInteraction } = useTracking();
  const [isUserUnder18, setIsUserUnder18] = useState(false);

  const [hidden, setHidden] = useHiddenWithCookie('france_age_confirmation');

  const { pathname } = useLocation();

  useEffect(() => {
    if (!hidden) {
      setHidden(true);
      setTimeout(() => setHidden(false), delay); // hide the modal for specified amount of time
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const hide = () => {
    setHidden(true);
    trackContentInteraction('yes', 'pop_ups', 'are_you_18');
  };

  const redirectToLanding = () => redirectTo(pathname, '/');

  if (hidden) {
    return <></>;
  }

  if (pathname.match(new RegExp('/my-femtasy'))) {
    return <></>;
  }

  return (
    <div className="FranceAgeConfirmationModal">
      <Popup trackingName="are_you_18" onClose={() => redirectToLanding()}>
        {isUserUnder18 ? (
          <Under18Modal />
        ) : (
          <AgeConfirmationModal
            onHide={hide}
            onConfirmationClick={setIsUserUnder18}
          />
        )}
      </Popup>
    </div>
  );
};

export default FranceAgeConfirmationModal;
